import List from "components/list";
import { getUserFields } from "components/user/config";
import { EmployeeCell } from "components/cell/employee/cell";
import { CURRENT_MONTH_END_DATE, CURRENT_MONTH_START_DATE } from "@/lib/utils";
import { DateCell } from "@/components/date/cell";
import MyTeamAcknowledgementFilters from "./filters";
import { useSelector } from "react-redux";
import { selectUser } from "store/src/slices/auth-slice";

export default function MyTeamAcknowledgementTable() {
    const user = useSelector(selectUser);
    const fields = [
        "id",
        "date",
        getUserFields("employee"),
        "is_logged",
    ];

    const COLUMNS = [
        {
            id: "date",
            header: "Date",
            accessorKey: "date",
            sortable: true,
            cell: DateCell,
        },
        {
            id: "employee",
            header: "Employee",
            accessorKey: "employee",
            cell: EmployeeCell,
        },
        {
            id: "is_logged",
            header: "Acknowledgement",
            accessorKey: "is_logged",
            cell: ({ row }) => {
                return row.original?.is_logged ? "Yes" : "No";
            },
        }
    ];

    const defaultFilters = {
        date: {
            _gte: CURRENT_MONTH_START_DATE,
            _lte: CURRENT_MONTH_END_DATE,
        },
        employee: {
            department: {
                _eq: user.department.id,
            }
        },
    }

    return (
        <div className="flex-1">
            <List
                title="Acknowledge"
                storageKey="Acknowledge-my-team"
                endPoint="daily_work_capacity"
                showSearch={false}
                perPage={10}
                columns={COLUMNS}
                filters={defaultFilters}
                sortBy="date"
                sortOrder="desc"
                teleportFilters={true}
                meta={{
                    fields
                }}
                renderFilters={MyTeamAcknowledgementFilters}
            />
        </div>
    );
}
